export default __webpack_public_path__ + "static/Corprate_WhoWeAre_02-1a473655069450546da47cc49518a2c3.jpg";